import React, { Component } from 'react'

import './index.scss'

class InputField extends Component {
    render() {
        const {
            isShowBottomText,
            bottomText,
            bottomTextColor
        } = this.props

        return (
            <div className="newform-inputfield-root-container">
                <input className="inputfield"
                    {...this.props}
                    style={{
                        borderBottomColor: isShowBottomText ? (bottomTextColor || 'red') : null
                    }}
                />
                {
                    <span
                        className="bottomtext"
                        style={{
                            visibility: isShowBottomText ? 'visible' : 'hidden',
                            color: bottomTextColor || 'red'
                        }}
                    >
                        {bottomText}
                    </span>
                }
            </div>
        )
    }
}

export default InputField